import React from 'react';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import HalfCardHeader from './HalfCardHeader';
import styles from './index.pcss';
import RatingProductCard from '../../RatingProductCard';
import properties from '../../../../modules/ajio-util/properties';
import { fetchRatingByUser } from '../../../../actions/ratings';
import { getFeedBackPendingProducts } from '../../../selectors/ratingSelector';
import { gtmEventPush, segmentEventPush } from '../../../../modules/ga/GTMdatalayer';
import { ModalDataType, FeedBackProductCardType } from '../types';
import { hideModal } from '../../../../actions/modal';
import { getCurrentStore } from '../../../selectors/metaData';
import { FLEEK_STORE_NAME } from '../../../../fleek/utils/constants';

const cx = classNames.bind(styles);
const imageBaseRef = `${properties.getProperty('imageBaseUrl')}/static/img/`;

interface FeedBackCardPropTypes {
  isFromPDP: boolean;
  modalData: ModalDataType;
  fetchRatingByUser: ({}) => void;
  feedBackPendingProducts: FeedBackProductCardType[];
  updateModal: (modalName: string, {}) => void;
  hideModal: () => void;
  closeModal: (modalName: string) => void;
}

const FeedBackCard = (props: FeedBackCardPropTypes) => {
  const {
    updateModal,
    fetchRatingByUser,
    feedBackPendingProducts,
    isFromPDP,
    hideModal,
    modalData,
    closeModal,
    currentStore
  } = props;
  const { sourcePage = '', pageName = '', pageType = '' } = modalData;
  const displayEmptyHalfCard = isFromPDP || feedBackPendingProducts.length === 0;
  const isFleek = currentStore === FLEEK_STORE_NAME;

  const ratingClickHandler = async ({
    rating,
    brandName,
    description,
    imageUrl,
    skuId,
    orderId = '',
    brickCode = ''
  }: {
    rating: number;
    brandName: string;
    description: string;
    imageUrl: string;
    skuId: string;
    orderId?: string;
    brickCode?: string;
  }) => {
    const responseFromRating = await fetchRatingByUser({
      sourcePage,
      skuData: skuId,
      rating,
      fetchSubRatingQuestion: true,
      fetchAggRating: false
    });
    gtmEventPush({
      event: 'reviews_rating_interactions',
      event_category: 'reviews & ratings interactions',
      event_action: 'overall rating',
      event_label: rating,
      ...(orderId.length > 0 && { order_id: orderId }),
      product_id: skuId,
      product_name: description,
      ...(brickCode.length > 0 && { product_brick: brickCode }),
      page_name: pageName,
      page_type: pageType,
      store_type: 'ajio'
    });
    // Segment Push Event
    segmentEventPush({
      event: 'Ratings Collected',
      event_category: 'reviews & ratings interactions',
      //event_action: 'overall rating',
      //event_label: rating,
      ...(orderId.length > 0 && { order_id: orderId }),
      // ...(brickCode.length > 0 && { product_brick: brickCode }),
      products:[{
        product_id: skuId,
        product_name: description,
      }],    
      rating_value: rating,
      screen_name: pageName,
      // page_type: pageType,
      store_type: 'ajio'
    });
    if (responseFromRating?.statusCode === 200) {
      updateModal('rating-halfcard', {
        state: {
          deviceType: 'mobile',
          rating,
          pageToDisplay: 'ratingHalfCard',
          productDetails: {
            brandName,
            description,
            imageUrl,
            skuId
          },
          displayFeedBackPage: true,
          isfromWriteFeedBack: false
        }
      });
    } else {
      updateModal('rating-halfcard', {
        state: {
          deviceType: 'mobile',
          rating: 0,
          pageToDisplay: 'ratingHalfCard',
          productDetails: {
            brandName,
            description,
            imageUrl,
            skuId
          },
          displayFeedBackPage: true,
          isfromWriteFeedBack: false,
          isFeedBackSubmitted: false
        }
      });
    }
  };

  const skipButtonHandler = () => {
    hideModal();
  };

  const continueButtonHandler = () => {
    closeModal('rating-halfcard');
  };

  const rateOtherClickHandler = () => {
    window.location.href = '/my-account/orders';
  };

  return (
    <div
      className={cx(
        `${displayEmptyHalfCard ? 'empty-feedback-card-container' : 'feedback-card-container'}`,
        isFleek ? 'fleek_empty-feedback-card-container' : ''
      )}
    >
      <HalfCardHeader
        feebackCard
        pendingFeedBacksIsEmpty={displayEmptyHalfCard}
        variant="mobile"
        brandName=""
        productName=""
      />
      {feedBackPendingProducts.length > 0 && !isFromPDP && (
        <div className={cx('feedback-content-container')}>
          <div className={cx('feedback-navigation')}>
            <p className={cx('navigation-heading')}>Pending Feedbacks</p>
            <button className={cx('navigation-cta')} onClick={rateOtherClickHandler}>
              <p>
                Rate Other Products
                <span>
                  <img
                    className={cx('imageIcon', 'side-arrow-container')}
                    src={`${imageBaseRef}blue-side-arrow.svg`}
                    alt="Right arrow"
                  />
                </span>
              </p>
            </button>
          </div>
          <div>
            <div className={cx('product-cards-container')}>
              {feedBackPendingProducts.map(product => {
                return (
                  <RatingProductCard
                    key={product.id}
                    brandName={product.brandName}
                    description={product.brandTitle}
                    productRating={0}
                    imageUrl={product.imageUrl}
                    productCode={product.productCode}
                    variant="mobile"
                    feedbackCard={false}
                    onRatingClickHandler={rating => {
                      ratingClickHandler({
                        rating,
                        brandName: product.brandName,
                        description: product.brandTitle,
                        imageUrl: product.imageUrl,
                        skuId: product.skuId
                      });
                    }}
                  />
                );
              })}
            </div>
            <button className={cx('skip-button')} onClick={skipButtonHandler}>
              <p className={cx('skip-button-content')}>Skip</p>
            </button>
          </div>
        </div>
      )}
      {displayEmptyHalfCard && (
        <button
          className={cx('continue-button', isFleek ? 'fleek_continue-button' : '')}
          onClick={continueButtonHandler}
        >
          <p className={cx('continue-button-content')}>Continue</p>
        </button>
      )}
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    ...ownProps,
    feedBackPendingProducts: getFeedBackPendingProducts(state),
    currentStore: getCurrentStore(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchRatingByUser: (reqObj = {}) => dispatch(fetchRatingByUser(reqObj)),
    closeModal: (name: string) => dispatch(hideModal(name))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FeedBackCard);
